import { KoAPI } from 'packages';

const BASE = '/v1/releases';
const GIT_BASE = '/v1/git';

export const ReleaseAPI = {
  // ── Release CRUD ────────────────────────────────────────────────
  getReleases: (params) =>
    KoAPI.get(BASE, { params }),

  getReleaseById: (releaseId) =>
    KoAPI.get(`${BASE}/${releaseId}`),

  createRelease: (data, releaseId) =>
    releaseId
      ? KoAPI.put(`${BASE}/${releaseId}`, data)
      : KoAPI.post(BASE, data),

  deleteRelease: (releaseId) =>
    KoAPI.delete(`${BASE}/${releaseId}`),

  // ── Tickets ─────────────────────────────────────────────────────
  getReleaseTickets: (releaseId, params) =>
    KoAPI.get(`${BASE}/${releaseId}/tickets`, { params }),

  linkTicket: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/tickets`, data),

  unlinkTicket: (releaseId, ticketId) =>
    KoAPI.delete(`${BASE}/${releaseId}/tickets/${ticketId}`),

  searchKwapioTickets: (query) =>
    KoAPI.get('/v1/tickets', { params: { search: query, limit: 20 } }),

  // ── Pull Requests ───────────────────────────────────────────────
  getReleasePRs: (releaseId, params) =>
    KoAPI.get(`${BASE}/${releaseId}/prs`, { params }),

  createPR: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/prs`, data),

  updatePR: (releaseId, prId, data) =>
    KoAPI.put(`${BASE}/${releaseId}/prs/${prId}`, data),

  getPRDiff: (releaseId, prId) =>
    KoAPI.get(`${BASE}/${releaseId}/prs/${prId}/diff`),

  getPRComments: (releaseId, prId) =>
    KoAPI.get(`${BASE}/${releaseId}/prs/${prId}/comments`),

  addPRComment: (releaseId, prId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/prs/${prId}/comments`, data),

  resolveComment: (releaseId, prId, commentId) =>
    KoAPI.put(`${BASE}/${releaseId}/prs/${prId}/comments/${commentId}/resolve`),

  approvePR: (releaseId, prId) =>
    KoAPI.post(`${BASE}/${releaseId}/prs/${prId}/approve`),

  rejectPR: (releaseId, prId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/prs/${prId}/reject`, data),

  mergePR: (releaseId, prId) =>
    KoAPI.post(`${BASE}/${releaseId}/prs/${prId}/merge`),

  // ── QA Testing ──────────────────────────────────────────────────
  getQATests: (releaseId, params) =>
    KoAPI.get(`${BASE}/${releaseId}/qa`, { params }),

  createQATest: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/qa`, data),

  updateQATest: (releaseId, testId, data) =>
    KoAPI.put(`${BASE}/${releaseId}/qa/${testId}`, data),

  fileQABug: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/qa/bugs`, data),

  // ── UAT ─────────────────────────────────────────────────────────
  getUATItems: (releaseId) =>
    KoAPI.get(`${BASE}/${releaseId}/uat`),

  updateUATItem: (releaseId, itemId, data) =>
    KoAPI.put(`${BASE}/${releaseId}/uat/${itemId}`, data),

  inviteUATStakeholder: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/uat/invite`, data),

  // ── Release Notes ───────────────────────────────────────────────
  generateReleaseNotes: (releaseId) =>
    KoAPI.post(`${BASE}/${releaseId}/notes/generate`),

  getReleaseNotes: (releaseId) =>
    KoAPI.get(`${BASE}/${releaseId}/notes`),

  updateReleaseNotes: (releaseId, data) =>
    KoAPI.put(`${BASE}/${releaseId}/notes`, data),

  sendReleaseEmail: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/notes/email`, data),

  // ── Release Gate ────────────────────────────────────────────────
  getReleaseGate: (releaseId) =>
    KoAPI.get(`${BASE}/${releaseId}/gate`),

  updateGateItem: (releaseId, itemKey, data) =>
    KoAPI.put(`${BASE}/${releaseId}/gate/${itemKey}`, data),

  approveGate: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/gate/approve`, data),

  // ── Deployment ──────────────────────────────────────────────────
  deployToProduction: (releaseId) =>
    KoAPI.post(`${BASE}/${releaseId}/deploy`),

  getDeploymentLogs: (releaseId) =>
    KoAPI.get(`${BASE}/${releaseId}/deploy/logs`),

  // ── Monitoring ──────────────────────────────────────────────────
  getMonitoringStatus: (releaseId) =>
    KoAPI.get(`${BASE}/${releaseId}/monitoring`),

  // ── Incident & Rollback ─────────────────────────────────────────
  createIncident: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/incidents`, data),

  triggerRollback: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/rollback`, data),

  // ── Metrics ─────────────────────────────────────────────────────
  getReleaseMetrics: (releaseId) =>
    KoAPI.get(`${BASE}/${releaseId}/metrics`),

  // ── Stage Advancement ───────────────────────────────────────────
  advanceStage: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/advance`, data),

  // ── Git Provider ────────────────────────────────────────────────
  getGitConnections: () =>
    KoAPI.get(`${GIT_BASE}/connections`),

  connectGitProvider: (data) =>
    KoAPI.post(`${GIT_BASE}/connect`, data),

  disconnectGitProvider: (connectionId) =>
    KoAPI.delete(`${GIT_BASE}/connections/${connectionId}`),

  getGitRepos: (connectionId) =>
    KoAPI.get(`${GIT_BASE}/connections/${connectionId}/repos`),

  getGitBranches: (connectionId, repoId) =>
    KoAPI.get(`${GIT_BASE}/connections/${connectionId}/repos/${repoId}/branches`),

  syncGitPRs: (releaseId, connectionId) =>
    KoAPI.post(`${BASE}/${releaseId}/prs/sync`, { connectionId }),

  raisePR: (releaseId, data) =>
    KoAPI.post(`${BASE}/${releaseId}/prs/raise`, data),

  getOAuthUrl: (provider) =>
    KoAPI.get(`${GIT_BASE}/oauth/${provider}/url`)
};
